import { SendEmail as SendEmailPage } from "@/components/Home/SendEmail";

const SendEmail = () => {
    return (
        <SendEmailPage />
    );
};

export default SendEmail;